module.exports = __webpack_public_path__ + "static/accenture-c23623d5c6276a2c49c2b7b61294e01d.png";